import { jsx as _jsx } from "react/jsx-runtime";
import { MessageBar, MessageBarType } from '@fluentui/react';
import { useAuth } from '@msrceng/auth';
import { MessageAuthErrorControls } from './MessageAuthErrorControls';
/** Message bar that shows the outcome of sign-in and auth errors */
export const MessageAuthError = ({ dismissButtonAriaLabel = 'Dismiss', }) => {
    const { clearError, error } = useAuth();
    if (error) {
        const message = handleCustomErrorMessage(error);
        if (!message) {
            return null;
        }
        return (_jsx(MessageBar, Object.assign({ messageBarType: MessageBarType.error, actions: _jsx(MessageAuthErrorControls, { error: error }), onDismiss: clearError, dismissButtonAriaLabel: dismissButtonAriaLabel }, { children: message })));
    }
    return null;
};
const handleCustomErrorMessage = (error) => {
    if (error.errorCode) {
        const authError = error;
        switch (authError.errorCode) {
            case 'temporarily_unavailable':
            case 'server_error':
                return 'The service is temporarily unavailable. Please try again later.';
            case 'interaction_required':
            case 'consent_required':
            case 'login_required':
            case 'invalid_grant':
                return 'Please sign in to continue.';
            case 'access_denied':
            case 'unauthorized_client':
                return 'You do not have permission to access this resource. If you expect to have access, please contact your administrator.';
            case 'monitor_window_timeout':
            case 'block_iframe_reload':
                return false;
            default:
                return authError.errorMessage;
        }
    }
    return error.message;
};
